export const pdfPreviewConfig = {
  pageContentHeightPx: 920,
}
